/* eslint-disable react/no-array-index-key */

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import RotatingCard, {
	RotatingCardFront,
	RotatingCardBack,
} from "examples/Cards/RotatingCard";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";
import CaseStudiesDrawer from "./caseStudies";
// const useStyles = makeStyles(() => ({
// 	skillsBox: {
// 		display: "flex",
// 		flexWrap: "wrap",
// 		justifyContent: "center",
// 		alignItems: "center",
// 		marginBottom: "1rem",

// 		"& > *": {
// 			margin: "1vw",
// 		},
// 	},
// }));
function HowWeCanHelp() {
	// const classes = useStyles();

	const mappedData = [
		{
			name: "Web & Mobile Development",
			description:
				"Having a mobile app to centralize your business operations and connect with your customers is increasingly the difference between successful and unsuccessful businesses. We can help you build a mobile app that will help you grow your business.",
		},
		{
			name: "Cloud Development",
			description:
				"We help businesses to migrate to the cloud and leverage the power of cloud computing in providing services the competition can't match.",
		},
		{
			name: "Data Services",
			description:
				"We specialize in buidling web scrapers and data pipelines that lets you draw insights from your data and your competitor's data.",
		},
	];

	return (
		<MKBox component="section" py={12} mt="1rem">
			<Container>
				<Grid
					container
					item
					xs={12}
					lg={6}
					justifyContent="center"
					sx={{ mx: "auto", textAlign: "center" }}
				>
					<MKTypography variant="h2">How we can collaborate!!</MKTypography>
				</Grid>
				<Grid container spacing={3} sx={{ mt: 4, mb: 6 }}>
					{mappedData.map((item) => (
						<Grid item xs={12} lg={3} sx={{ mx: "auto" }}>
							<RotatingCard>
								<RotatingCardFront
									image={bgFront}
									title={item.name}
									description={item.description}
								/>
								<RotatingCardBack
									image={bgBack}
									description={item.description}
									action={{
										type: "external",
										// route: item.links.live,
										label: "Link",
									}}
								/>
							</RotatingCard>
						</Grid>
					))}
				</Grid>
				<Grid
					container
					item
					xs={12}
					lg={6}
					justifyContent="center"
					sx={{ mx: "auto", textAlign: "center", marginBottom: "2rem" }}
				>
					<MKTypography variant="h2">Our case studies!!</MKTypography>
				</Grid>
				<CaseStudiesDrawer />
			</Container>
		</MKBox>
	);
}

export default HowWeCanHelp;
